/* esm.sh - applesauce-common@5.2.0/dist/blueprints/delete */
export * from "/*applesauce-common@5.2.0/esnext/dist/blueprints/delete.mjs";
